import {Component, OnInit} from '@angular/core';
import {ThemeConstantService} from '../../services/theme-constant.service';
import {AccountService, EventManager, IUser} from '../../../core';
import {Router} from '@angular/router';
import {LoginService} from '../../../core/services';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import {HttpResponse} from "@angular/common/http";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  searchVisible = false;
  quickViewVisible = false;
  isFolded: boolean;
  isExpand: boolean;
  accountInfo: any;
  theme: string = 'primary';
  dynamicColor: {color: string, color1: string, color2: string, color3: string, color4: string, color5: string } = {color: '', color1: '', color2: '', color3: '', color4: '', color5: ''};
  selectedColor: string = '';
  cssContent: string = '';
  variableFields: any = {};
  color: any;
  constructor(
    private themeService: ThemeConstantService,
    private loginService: LoginService,
    private $localStorage: LocalStorageService,
    private accountService: AccountService,
    private sessionStorageService: SessionStorageService,
    private eventManager: EventManager,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.accountInfo = this.accountInfo ||  this.sessionStorageService.retrieve('USER_PROFILE') || {};
    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
    this.accountService.authenticationState
    .subscribe((acc) => {
      this.accountInfo = acc || {};
    })
  }

  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
  }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
  }

  isAuthenticated() {
    return this.accountService.isAuthenticated();
  }

  logout() {
    this.loginService.logout();
    this.router.navigate(['/authentication/login']);
  }
  setUpDynamic() {
    this.variableFields = this.$localStorage.retrieve('variable_theme' );
    this.dynamicColor.color = this.variableFields[`${'dynamic-theme-main-color'}`];
    this.dynamicColor.color1 = this.variableFields[`${'dynamic-theme-color'}`];
    this.dynamicColor.color2 = this.variableFields[`${'dynamic-theme-color-2'}`];
    this.dynamicColor.color3 = this.variableFields[`${'dynamic-theme-color-3'}`];
    this.dynamicColor.color4 = this.variableFields[`${'dynamic-theme-color-4'}`];
    this.dynamicColor.color5 = this.variableFields[`${'dynamic-theme-color-5'}`];
  }
  changeTheme(theme) {
    this.theme = theme;
    this.eventManager.broadcast({
      name: 'change-theme',
      content: {
        theme
      }
    });
    setTimeout(() => {
      this.setUpDynamic();
    }, 1000)
  }
  changeColor(selectedColor) {
    switch (selectedColor) {
      case 'color':
        document.documentElement.style.setProperty(`--dynamic-theme-main-color`, this.dynamicColor.color);
        this.$localStorage.store('dynamic-theme-main-color', this.dynamicColor.color);
      break;
      case 'color1':
        document.documentElement.style.setProperty(`--dynamic-theme-color`, this.dynamicColor.color1);
        this.$localStorage.store('dynamic-theme-color', this.dynamicColor.color1);
      break;
      case 'color2':
        document.documentElement.style.setProperty(`--dynamic-theme-color-2`, this.dynamicColor.color2);
        this.$localStorage.store('dynamic-theme-color-2', this.dynamicColor.color2);
      break;
      case 'color3':
        document.documentElement.style.setProperty(`--dynamic-theme-color-3`, this.dynamicColor.color3);
        this.$localStorage.store('dynamic-theme-color-3', this.dynamicColor.color3);
      break;
      case 'color4':
        document.documentElement.style.setProperty(`--dynamic-theme-color-4`, this.dynamicColor.color4);
        this.$localStorage.store('dynamic-theme-color-4', this.dynamicColor.color4);
      break;
      case 'color5':
        document.documentElement.style.setProperty(`--dynamic-theme-color-5`, this.dynamicColor.color5);
        this.$localStorage.store('dynamic-theme-color-5', this.dynamicColor.color5);
      break;
    }
  }
}
